import {
  ShoppingCart, Utensils, Film, Sparkles, ShoppingBag, HeartPulse, Hammer,
  Home, Trees, Shirt, PiggyBank, CreditCard, Car, Zap, Package, Plane,
  Dumbbell, Coffee, Gift, GraduationCap, Baby, PawPrint, Wallet, Fuel, Wifi,
} from "lucide-react";

const RULES = [
  [/amazon|online|marketplace|etsy/, Package],
  [/grocer|supermarket|market|food/, ShoppingCart],
  [/din|restaurant|eat|takeout|lunch|dinner/, Utensils],
  [/coffee|cafe|starbucks/, Coffee],
  [/entertain|movie|stream|netflix|game/, Film],
  [/glam|beauty|salon|cosmet|hair|nail/, Sparkles],
  [/health|medical|pharma|doctor|dental|clinic/, HeartPulse],
  [/fit|gym|workout/, Dumbbell],
  [/home ?improve|renov|hardware|furnitur/, Hammer],
  [/hous|rent|mortgage/, Home],
  [/landscap|garden|lawn|yard/, Trees],
  [/cloth|apparel|personal|shopping|shoe/, Shirt],
  [/sav|invest|retire/, PiggyBank],
  [/subscri|misc|membership/, CreditCard],
  [/transport|fuel|gas|car|auto|transit|uber|lyft/, Car],
  [/util|electric|water|energy/, Zap],
  [/internet|phone|wifi|cable|comcast/, Wifi],
  [/travel|flight|vacation|hotel/, Plane],
  [/gift|present|donat/, Gift],
  [/educat|school|tuition|book/, GraduationCap],
  [/kid|child|baby|daycare/, Baby],
  [/pet|dog|cat|vet/, PawPrint],
  [/pump|petrol/, Fuel],
];

export const getCategoryIcon = (name = "") => {
  const n = name.toLowerCase();
  for (const [re, Icon] of RULES) {
    if (re.test(n)) return Icon;
  }
  return Wallet;
};
